export const getFilters = state => state.transports.filters;
export const getPaging = state => state.transports.paging;
export const getItems = state => state.transports.items;
export const getUser = state => state.user;
